module.exports = __webpack_public_path__ + "img/not-fixed.3821f600.svg";